exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "upd-forgot-password-page {\n  display: block;\n  padding: 20px;\n}\n\n  upd-forgot-password-page .forgot-password-box {\n    max-width: 600px;\n    background: #f5f5f5;\n    margin: 20px auto 40px auto;\n    padding: 20px 50px 40px;\n    text-align: center;\n  }\n", ""]);

